/**
 * react-query 클라이언트
 * ---------------------------------------------------------------------------
 * main.tsx 안에 두었더니 화면 밖(axios 인터셉터)에서 캐시를 건드릴 수 없었다.
 * main.tsx 를 import 하면 순환 참조가 되므로 여기로 옮겼다.
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 현장에서 같은 화면을 오래 띄워 두는 일이 많다. 창을 다시 볼 때
      // 자동으로 최신화되는 편이 "왜 남이 쓴 일지가 안 보이지" 보다 낫다.
      refetchOnWindowFocus: true,
      staleTime: 10_000,
      retry: 1,
    },
  },
});
